
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { fullScreenLoadingSlice } from "../../../../data/redux/slice/loaderSlice";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
import {
  fetchAllApprovalList,
  fetchAllPendngList,
} from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import {
  colorWhite,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  ACTIVE,
  ADMIN,
  ADMIN_USER,
  APPROVE,
  PENDING,
  REJECT,
  RNC,
  RNCAPPROVED,
  RNCPENDING,
  RNCREJECTED,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../utility/ResizeListner";
import {
  PendingListHeaders,
  PendingListHeadersRnc,
} from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import AlertModals from "../../../components/ui_comps/AlertModals";


const ConfirmationModal = ({ onClose }) => {
  return (
    <>
      <div
        style={{
          color: primaryColor,
          fontWeight: "500",
          textAlign: "center",
          marginBottom: 20,
          alignItems: "center",
        }}
      >
        Client Rejected
      </div>
      <p style={{ textAlign: "center", color: "#6C6B6B", margin: 30 }}>
        Client has been rejected we will notify the onboarded person about it
      </p>
      <div style={{ width: "fit-content", margin: "auto" }}>
        <CustomButton title={"Ok"} onClick={onClose} />
      </div>
    </>
  );
};

function PendingApproval({ onChange, status }) {
  const { height } = ResizeListner();
  const [ setCurrentPage] = useState(0);
  const dispatch = useDispatch();
  const [clientData, setClientData] = useState({});
  const [onClickViewMore, setOnClickViewMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [modal, setModal] = useState(false);
  const approvalData = useSelector((state) => state.listingSlice.approvalList);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const role = secureStorage.getItem(SS_ROLE);
  const { enqueueSnackbar } = useSnackbar();

  const onClickApproveReject = (clientId, Approva_status, reason = "") => {
    dispatch(fullScreenLoadingSlice(true));
    ApiRequestPost.adminApproveRejectAction({
      clientId,
      status: Approva_status,
      reason,
    })

      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          if (response.message === "Client Request Rejected Successfully") {
            setConfirm(true);
          }

          enqueueSnackbar(response.message, {
            variant: "success",
          });

          dispatch(
            fetchAllApprovalList({
              dateRange: "",
              page: 0,
              size: 10,
              activeStatus: ACTIVE,
              onBoardedStatus: status,
              userRefId: "",
            })
          );
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
        setLoading(false);
      })
      .finally(() => {
        dispatch(fullScreenLoadingSlice(false));
      });
  };

  useEffect(() => {
    dispatch(
      fetchAllPendngList({
        dateRange: "",
        page: 0,
        size: 10,
        activeStatus: ACTIVE,
        onBoardedStatus: status,
        userRefId: "",
      })
    );
  }, [loading, status, clientData]);

  return (
    <div>
      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          currentPage={approvalData?.currentPageNo - 1}
          data={approvalData?.clients}
          headers={
            status === PENDING
              ? setHeaders(PendingListHeaders, aclData)
              : status === RNCPENDING
              ? setHeaders(PendingListHeadersRnc, aclData)
              : ""
          }
          totalElements={approvalData?.totalRecords}
          totalPages={approvalData?.totalPages}
          handlePaginate={(page) => {
            setCurrentPage(page);
            dispatch(
              fetchAllPendngList({
                dateRange: "",
                page: page + 1,
                size: 10,
                // activeStatus: { ACTIVE },
                onBoardedStatus: status,
                userRefId: "",
              })
            );
          }}
          onViewMore={(row) => {
            onChange(true, row);
          }}
          onClickAccept={(data) => {
            onClickApproveReject(
              data?.userId,
              role === RNC
                ? RNCAPPROVED
                : role === ADMIN
                ? APPROVE
                : role === ADMIN_USER
                ? APPROVE
                : ""
            );
          }}
          onClickReject={(data) => {
            setOnClickViewMore(true);
            setClientData(data);
          }}
        />
      </div>
      {modal && (
        <>
          <CustomModal
            open={modal}
            onClose={() => {
              setModal(false);
            }}
            isHeaderRequired={true}
            containerStyle={{
              height: 300,
              width: 500,
            }}
          >
            <p
              style={{
                color: "#38369C",
                fontWeight: "500",
                fontSize: "18px",
                marginTop: "20%",

                textAlign: "center",
              }}
            >
              Client Onboarded successfully
            </p>
            <p
              style={{
                color: "#6C6B6B",
                fontWeight: "400",
                fontSize: "14px",
                marginTop: "20px",
                textAlign: "center",
              }}
            >
              The client has been approved and will receive a mail with the
              details and the document
            </p>
            <CustomButton
              title="OK"
              styles={{
                width: "30%",
                backgroundColor: primaryColor,
                border: "none",
                margin: "auto",
                marginTop: "20px",
              }}
              textStyles={{
                color: colorWhite,
              }}
              onClick={() => {
                setModal(false);
              }}
            />
          </CustomModal>
        </>
      )}
      {onClickViewMore && (
        <CustomModal
          headerTitle=""
          open={onClickViewMore}
          onClose={() => {
            setOnClickViewMore(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          {confirm ? (
            <ConfirmationModal
              onClose={() => {
                setOnClickViewMore(false);
                setConfirm(false);
              }}
            />
          ) : (
            <AlertModals
              confirmButtonTitle={"Reject"}
              title={true}
              isConditional={false}
              onClickCancel={() => setOnClickViewMore(false)}
              onClickOk={(reason) => {
                if (reason) {
                  onClickApproveReject(
                    clientData?.userId,
                    role === RNC
                      ? RNCREJECTED
                      : role === ADMIN
                      ? REJECT
                      : role === ADMIN_USER
                      ? REJECT
                      : "",
                    reason
                  );
                } else {
                  enqueueSnackbar("Please enter reason for rejecting", {
                    variant: "error",
                  });
                }
              }}
              loading={loading}
              action={"reject"}
              reason={"reject"}
              data={clientData}
            />
          )}
        </CustomModal>
      )}
    </div>
  );
}

export default PendingApproval;
